import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box
} from "@mui/material";
import React from "react";
import { palette } from "../../theme";

export type SidebarItemData = {
  label: string,
  icon?: React.ReactNode,
  route?: string,
};

interface SidebarItemProps {
  label: string;
  icon?: React.ReactNode;
  selected: boolean;
  expanded: boolean;
  onClick: () => void;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  label,
  icon,
  selected,
  expanded,
  onClick,
}) => {

  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={onClick}
        sx={{
          px: 3,
          py: 1.5,
          minHeight: 48,
          gap: 1.5,
          borderLeft: selected ? "2px solid #0E6FFF" : "2px solid transparent",
          bgcolor: selected ? "#0E6FFF0D" : "transparent",
          color: selected ? "#0E6FFF" : "#0B1620",
          "&:hover": {
            bgcolor: selected ? "#0E6FFF0D" : "#F5F7FA",
          },
          justifyContent: expanded ? "flex-start" : "center",
        }}
      >
        {icon && (
          <ListItemIcon
            sx={{
              minWidth: expanded ? "32px" : "auto",
              color: "inherit",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& svg": {
                width: "20px",
                height: "20px",
              },
            }}
          >
            {icon}
          </ListItemIcon>
        )}
        {expanded && (
          <Box
            component="span"
            sx={{
              fontSize: "13px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </Box>
        )}
      </ListItemButton>
    </ListItem>
  );
};

export default SidebarItem;
